import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import * as ROUTES from '../../../../../constants/routes';
import styled from 'styled-components';
import * as MDICONS from '@material-ui/icons';
import ReactModal from 'react-modal';
import { get } from 'lodash'
import { Radar } from 'react-chartjs-2';

class StatsTagCard extends Component {
    constructor(props) {
        super(props)

        this.state = {

        }
    }

    /// README: Compare to sort
    compare(a, b) {
        if ('name' in a && 'name' in b) {
            if (a.name && b.name) {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
            }
        }
        return 0;
    }

    /// README: MODAL CONTROLLING
    handleOpenModal = (num) => {
        switch (num) {
            default: {
                this.setState({});
                break;
            }
        }
    }

    handleCloseModal = (num) => {
        switch (num) {
            default: {
                this.setState({});
                break;
            }
        }
    }

    componentDidMount() {
        this.setState({

        })
    }

    render() {
        const {
            themeColors, alu, userData, companyData, snagDetail, modalStyles, project, commonLabels,
            modalInfoTextStyle,
        } = this.props;
        const { accessMap } = snagDetail;
        const { udefectMarkers, udefectMarker, utagCategory, utagCategories, tagCategory } = commonLabels;
        const { uid, employeeid } = userData;
        const ueid = uid + employeeid;

        
        var hasAllTags = accessMap ? ueid in accessMap ? accessMap[ueid]['hasAllTags']:false:false;
        var selectedTagsIdList = accessMap ? ueid in accessMap ? accessMap[ueid]['selectedTagsIdList']:[]:[];
        var filterAllTagsMap = 'allTagsMap' in snagDetail ? Object.keys(snagDetail.allTagsMap).length > 1 ? Object.values(snagDetail.allTagsMap).sort(this.compare):[]:[];
        filterAllTagsMap = filterAllTagsMap.filter(val => (val.tagid !== "elevation"));
        filterAllTagsMap = filterAllTagsMap.filter(val=> (!val.name.includes('[DELETED]')));
        if(!hasAllTags){
            filterAllTagsMap = filterAllTagsMap.filter(val=> selectedTagsIdList.includes(val.tagid));
        }
        var tagCounter = [];
        var tagNames = [];
        Object.values(filterAllTagsMap).sort(this.compare).forEach((val, i) => {
            tagCounter.push(val.count)
            tagNames.push(val.name)
        })

        const data = {
            labels: tagNames,
            datasets: [
                {
                    label: '',
                    data: tagCounter,
                    backgroundColor: 'rgba(20, 56, 150, 0.4)',
                    borderColor: 'rgba(20, 56, 150, 1)',
                    borderWidth: 1,
                },
            ],
        }

        const options = {
            legend: {
                display: false
            },
            title: {
                display: false,
                text: ""
            },
            scale: {
                pointLabels: {
                    fontSize: 14
                }
            }
        }

        return (
            <div className="card p-2 " style={{ borderRadius: '15px' }}>
                <div className="card-header bg-white p-0 mx-2">
                    <div className="row">
                        <div className="col-8">
                            <p style={{ textAlign: "start", fontWeight: "bold", fontSize: "18px" }}>{utagCategory} metrics</p>
                        </div>
                        <div className="col-4">
                        </div>
                    </div>
                    <p style={modalInfoTextStyle}>Tag {tagCategory} metrics is based on the entire project.</p>
                </div>
                <div className="card-body">
                    {/* GRAPHS */}
                    <Radar data={data} height={120} options={options} />
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        alu: state.alu,
        
        commonLabels: state.commons,
        userData: state.firebase.profile,
        companyData: state.firestore.data.Company,

        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),

        // styles
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
        modalStyles: state.appControl.modalStyles,
    }
}

export default connect(mapStateToProps)(StatsTagCard)
